import React from 'react'
import {
  SidebarContainer,
  Logo,
  LogoText,
  LogoSubtext,
  LogoTextBlock,
  ToggleButton
} from './Sidebar.styles'
import { SidebarItemLink } from '../../shared/ui/SidebarItemLink'
import { nestedRoutes } from '../../shared/constants/routes'
import { useLivingComplex } from '../../shared/hooks/api'
import { useParams } from 'react-router-dom'
import { Icon } from '../../shared/ui/Icon'

interface SidebarProps {
  collapsed: boolean
  onToggle: () => void
}

export const Sidebar: React.FC<SidebarProps> = ({ collapsed, onToggle }) => {
  const { livingComplexId } = useParams<{ livingComplexId: string }>()
  const { data: livingComplex } = useLivingComplex(livingComplexId ?? '')
  const lcName = livingComplex?.name

  return (
    <SidebarContainer $collapsed={collapsed}>
      <Logo $collapsed={collapsed}>
        <ToggleButton
          type="button"
          onClick={onToggle}
          aria-label={collapsed ? 'Показать меню' : 'Скрыть меню'}
          $collapsed={collapsed}
        >
          {collapsed ? (
            <Icon type="sidebar_right" size={24} />
          ) : (
            <Icon type="sidebar_left" size={24} />
          )}
        </ToggleButton>
        {!collapsed ? (
          <LogoTextBlock>
            <LogoText>BuildFlow</LogoText>
            <LogoSubtext>{lcName || 'Паспорт проекта'}</LogoSubtext>
          </LogoTextBlock>
        ) : null}
      </Logo>

      <SidebarItemLink
        to={nestedRoutes.home}
        end
        icon="document"
        text="Документация"
        collapsed={collapsed}
      />
      <SidebarItemLink
        to={nestedRoutes.costEstimates}
        icon="estimates"
        text="Сметы"
        collapsed={collapsed}
      />
      <SidebarItemLink
        to={nestedRoutes.budgets}
        icon="budget"
        text="Бюджеты"
        collapsed={collapsed}
      />
    </SidebarContainer>
  )
}
